<template>
    <div v-if="show" class="z-10 fixed inset-0 bg-neutral-900	bg-opacity-10">
        
        <div class="h-[500px] w-[500px] absolute inset-0 m-auto bg-white border rounded flex flex-col">
            <div class="flex px-3 py-2 border border-b-1 border-t-0 border-x-0	">
                <h1 class="flex-1"> {{ title }} </h1>
                <svg xmlns="http://www.w3.org/2000/svg" fill="black" @click.stop="close"
                viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6 cursor-pointer">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                </svg>
            </div>
            <div class="flex-1 p-5 flex flex-col">
                <div class="flex-1">
                    <p > Name: {{ user.firstName + ' ' + user.lastName }} </p>
                    <p class=" mt-4"> Email: {{ user.email }} </p>
                    <p class=" mt-4"> CreatedAt: {{ new  Date(user.createdAt).toLocaleDateString("en-CA") }} </p>
                    <p> 
                        <label class="inline-flex items-center cursor-pointer mt-4">
                            <span class="text-sm font-medium text-gray-900 me-4 w-20">Active: </span>
                            <input type="checkbox" value="" v-model="user.active" class="sr-only peer">
                            <div class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none 
                            peer-focus:ring-0 peer-focus:ring-blue-300
                            rounded-full peer peer-checked:after:translate-x-full 
                            rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white 
                            after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white 
                            after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 
                            after:transition-all peer-checked:bg-blue-600"></div>
                        </label>
                    </p>
                    <p> 
                        <label class="inline-flex items-center cursor-pointer mt-4">
                            <span class="text-sm font-medium text-gray-900 me-4 w-20">PremiumPlan: </span>
                            <input type="checkbox" value="" v-model="user.premiumPlan" class="sr-only peer">
                            <div class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none 
                            peer-focus:ring-0 peer-focus:ring-blue-300 
                            rounded-full peer peer-checked:after:translate-x-full 
                            rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white 
                            after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white 
                            after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 
                            after:transition-all peer-checked:bg-blue-600"></div>
                        </label>
                    </p>
                    <p class=" mt-4">  
                        <span>Plan:</span>
                    
                        <select name="action" id="action" class="border m-2 rounded h-8" v-model="user.plan">
                            <option :value="undefined">No Plan</option>
                            <option value="BASIC">BASIC</option>
                            <option value="ADVANCED">ADVANCED</option>
                            <option value="PREMIUM">PREMIUM</option>
                        </select>
                    </p>
                    <p class=" mt-4"> FailedInvoice: {{ user.failedInvoice || '-'}} </p>
                </div>

                <div class="flex">
                    <button :disabled="loading" @click="close"
                    class="cursor-pointer rounded-md mt-6 line-height-5 border mx-1
                    bg-white py-2 px-4 w-full font-weight-bold m-auto ">Cancel</button>

                    <button :disabled="loading" @click="updateUser"
                    class="cursor-pointer text-white rounded-md mt-6 line-height-5 mx-1
                    bg-gray-700 py-2 px-4 w-full font-weight-bold m-auto ">Okay</button>
                </div>
               


            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    name: 'PopupMessage',
    props:['title'],
    components: {

    },
    async mounted(){

    },
    data () {
        return {
            show:false,
            query:{},
            user:{},
            loading:false
        }
    }, 
    methods: {
        open:function(query){
            this.show=true;
            this.user = query.User
            if(query){this.query = {...query}}
        },
        close:function(e){
            this.show=false;
        },
        confirmed(){
            this.close();
        },
        async updateUser(){
            if(!this.$store.state.user || !this.$store.state.user.email){return}

            this.loading = true;


            const res = await this.$store.state.axiosInstance({
                method: "PUT",
                url: this.$store.state.API_ENDPOINT + '/v1/admin/users/'+ this.user._id,
                data: this.user,
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
            });

            this.loading = false;
            if(res.data && res.data.data){
                this.$store.state.toastr.open({timeOut:5000, type:"success", 
                title:'Success ', text: 'user saved successfully'});
            }else {
                this.$store.state.toastr.open({timeOut:5000, type:"error", 
                title:'Failed ', text: 'update user failed'});
            } 
      },
    }
}
</script>
 
<style>
 
</style>
  


// WEBPACK FOOTER //
// src/components/Admin/EditUser.vue